import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, Grid } from '@material-ui/core';
// images
import Background from '../../assets/Trazer/Rectangle.png';
import LogoSB from '../../assets/logoSBTracenegativo.png';
import LogoTS from '../../assets/ThomasSigneTRACEneg.png';
import BottomLinks from './BottomLinks';
import withWidth from '@material-ui/core/withWidth';
import SearchNav from './SearchNav';
import SearchBar from './SearchBar';
import { useWindowSize } from '../../customHooks/useWindowSize';
import { withRouter } from 'react-router-dom';
import translate from '../../i18next/funcTranslateHelper';
import ChangeLanguage from '../ChangeLanguage/ChangeLanguage';
const urls = process.env.REACT_APP_GOUZE_FRONT_URL.split(',');

const logo = require('../../assets/signeblock1.png');

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundImage: `url(${Background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundAttachment: 'fixed',
    backgroundPosition: 'center',
    position: 'relative'
  },
  paper: {
    height: '100%',
    width: '100%'
  },
  control: {
    padding: '0px'
  },
  mainContainer: {
    height: '100%',
    [theme.breakpoints.down('md')]: {
      padding: 0
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 1140,
      padding: 0
    }
  },
  mainGrid: {
    height: '100%'
  },
  topItemContainerGrid: {
    position: 'relative'
  },
  itemHeader: {
    padding: 0,
    display: 'flex'
  },
  headerBrand: {
    width: '100%',
    minWidth: 166,
    [theme.breakpoints.down('md')]: {
      padding: 0,
      paddingLeft: theme.spacing(2),
      paddingTop: 35.7
    },
    [theme.breakpoints.up('md')]: {
      padding: 0,
      paddingTop: 46.4
    }
  },
  mainContainerTopItem: {
    maxWidth: '100%',
    padding: 0,
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }
  },
  mainContainerTopItemContent: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 135,
      minWidth: 878
    },
    [theme.breakpoints.up('sm')]: {
      paddingTop: 135,
      maxWidth: 878,
      width: '100%'
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 74
    }
  },
  heroText: {
    fontFamily: 'Roboto-Light',
    fontSize: '40px',
    color: '#FFFFFF',
    letterSpacing: '0px',
    lineHeight: '36px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '34px'
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '40px'
    }
  }
}));

const Trazer = (props) => {
  const classes = useStyles();
  const size = useWindowSize();

  const [uploadingFile, setUploadingFile] = useState(false);
  const [hashType, setHashType] = useState('hash');
  const [hashPlaceholder, setHashPlaceholder] = useState(translate('Trazer:searchBarPlaceholder:hash'));

  const giveMePlaceholder = (route) => {
    let type;
    switch (route) {
      case 'identity':
        type = translate('Trazer:searchBarPlaceholder:identity');
        break;
      case 'contract':
        type = translate('Trazer:searchBarPlaceholder:contract');
        break;
      case 'asset':
        type = translate('Trazer:searchBarPlaceholder:asset');
        break;
      case 'hash':
        type = translate('Trazer:searchBarPlaceholder:hash');
        break;
      default:
        type = translate('Trazer:searchBarPlaceholder:default');
        break;
    }
    return type;
  };

  const handleChange = (event, newValue) => {
    setHashType(newValue);
    setHashPlaceholder(giveMePlaceholder(newValue));
  };
  console.log(urls[2]);

  return (
    <div
      className={classes.root}
      style={{ overflow: 'auto', position: 'relative', display: 'flex' }}
    >
      <ChangeLanguage />
      <Container className={classes.mainContainer}>
        <Grid
          container
          direction='row'
          alignItems='space-between'
          className={classes.mainGrid}
          style={{ height: size.height }}
        >
          <Grid
            container
            direction='row'
            justify='flex-start'
            alignItems='flex-start'
            className={classes.topItemContainerGrid}
          >
            <Grid item xs={3} className={classes.itemHeader}>
              <img
                src={window.location.hostname === urls[2] ? LogoTS : LogoSB}
                alt='Logo gouze'
                className={classes.headerBrand}
              />
            </Grid>
            <Grid
              container
              item
              direction='column'
              xs={12}
              className={classes.mainContainerTopItem}
            >
              <Grid item className={classes.mainContainerTopItemContent}>
                <Grid item>
                  <Typography className={classes.heroText} align='left'>
                    {size.width > 722 ? (
                      'Trace whatever, whenever you need it.'
                    ) : (
                      <>
                        Trace whatever <br /> whenever you need it.
                      </>
                    )}
                  </Typography>
                </Grid>
                <Grid item>
                  <SearchNav
                    hashType={hashType}
                    handleChange={handleChange}
                    hashPlaceholder={hashPlaceholder}
                    origin='searcher'
                  />
                  <SearchBar
                    uploadingFile={uploadingFile}
                    setUploadingFile={status => setUploadingFile(status)}
                    hashType={hashType}
                    setHashType={name => setHashType(name)}
                    hashPlaceholder={hashPlaceholder}
                    setHashPlaceholder={name => setHashPlaceholder(name)}
                    origin='searcher'
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            item
            direction='row'
            xs={12}
            className={classes.BottomLinksContainer}
            justify='space-between'
            alignItems='flex-end'
          >
            <Grid item>
              <BottomLinks
                textColor='#9B9B9B'
                style={{
                  marginBottom: size.width > 940 ? 19.5 : 18
                }}
                origin='searcher'
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <div
        style={{
          borderTopLeftRadius: 11,
          opacity: 0.7,
          background: '#FFFFFF',
          position: 'absolute',
          bottom: 0,
          right: 0,
          height: size.width >= 768 ? 83 : 80,
          maxWidth: size.width >= 768 ? 410 : size.width >= 600 ? '53%' : '46%',
          width: '100%'
        }}
      >
        <Grid
          container
          justify={size.width > 687 ? 'space-between' : 'center'}
          direction={size.width <= 375 ? 'column' : 'row'}
          alignItems={size.width <= 375 ? 'flex-start' : 'center'}
          style={{
            height: '100%',
            paddingLeft: size.width <= 375 ? 21 : 42,
            paddingRight: 43
          }}
        >
          <Grid item>
            <Typography
              style={{
                fontFamily: 'Roboto-Medium',
                fontSize: size.width <= 375 ? 10 : 14,
                marginBottom: size.width <= 375 ? 5.4 : 0,
                color: '#565656',
                letterSpacing: 0,
                textAlign: 'center'
              }}
            >
              A tool powered by:
            </Typography>
          </Grid>
          <Grid item>
            <img
              src={logo}
              alt='Logo de signeblock'
              height={size.width <= 375 ? 27 : 34}
              width={size.width <= 375 ? 125 : 162}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default withRouter(withWidth()(Trazer));
